import React from 'react';
import PublicNav from '../../components/PublicNav/PublicNav';
import PublicFooter from '../../components/PublicFooter/PublicFooter';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-page">
      <PublicNav />
      <main className="terms-of-service-content">
        <div className="terms-of-service-container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using ProjectPro ("Service," "Platform," "we," "us," or "our"), you accept and agree 
              to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use 
              our Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              ProjectPro is a comprehensive project portfolio management platform that provides tools for project 
              planning, tracking, collaboration, resource management, and reporting. We reserve the right to modify, 
              suspend, or discontinue any aspect of the Service at any time.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. User Accounts</h2>
            <h3>3.1 Account Registration</h3>
            <p>To use certain features of the Service, you must register for an account. You agree to:</p>
            <ul>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and update your information to keep it accurate</li>
              <li>Maintain the security of your password and account</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Notify us immediately of any unauthorized use</li>
            </ul>

            <h3>3.2 Account Eligibility</h3>
            <p>
              You must be at least 18 years old to use this Service. By using the Service, you represent and warrant 
              that you meet this requirement.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights of others</li>
              <li>Upload or transmit viruses, malware, or harmful code</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Use the Service for any illegal or unauthorized purpose</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Collect or store personal data about other users</li>
              <li>Use automated systems to access the Service without permission</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Intellectual Property</h2>
            <h3>5.1 Our Rights</h3>
            <p>
              The Service and its original content, features, and functionality are owned by ProjectPro and are 
              protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>

            <h3>5.2 Your Content</h3>
            <p>
              You retain ownership of any content you submit to the Service. By submitting content, you grant us a 
              worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display your content 
              solely for the purpose of providing the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Subscription and Payment</h2>
            <h3>6.1 Fees</h3>
            <p>
              Certain features of the Service require payment of fees. You agree to pay all applicable fees as 
              described on our pricing page. All fees are non-refundable unless otherwise stated.
            </p>

            <h3>6.2 Billing</h3>
            <p>
              Subscription fees are billed in advance on a recurring basis (monthly or annually). Your subscription 
              will automatically renew unless you cancel before the renewal date.
            </p>

            <h3>6.3 Price Changes</h3>
            <p>
              We reserve the right to change our fees at any time. We will provide you with reasonable notice of 
              any fee changes.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Termination</h2>
            <h3>7.1 By You</h3>
            <p>
              You may terminate your account at any time by contacting us or using the account settings. Upon 
              termination, your right to use the Service will immediately cease.
            </p>

            <h3>7.2 By Us</h3>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, 
              for any reason, including breach of these Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Disclaimers</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR 
              IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, 
              AND NON-INFRINGEMENT.
            </p>
            <p>
              We do not warrant that the Service will be uninterrupted, secure, or error-free, or that defects will 
              be corrected.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, PROJECTPRO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
              SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED 
              DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless ProjectPro and its officers, directors, employees, 
              and agents from any claims, liabilities, damages, losses, and expenses arising out of or related to 
              your use of the Service or violation of these Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Data Protection and Privacy</h2>
            <p>
              Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy to 
              understand how we collect, use, and protect your personal information.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Third-Party Services</h2>
            <p>
              The Service may contain links to third-party websites or services. We are not responsible for the 
              content, privacy policies, or practices of third-party websites or services.
            </p>
          </section>

          <section className="terms-section">
            <h2>13. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify you of any material changes by 
              posting the new Terms on this page and updating the "Last Updated" date. Your continued use of the 
              Service after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>14. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India, without regard 
              to its conflict of law provisions.
            </p>
          </section>

          <section className="terms-section">
            <h2>15. Dispute Resolution</h2>
            <p>
              Any disputes arising out of or relating to these Terms or the Service shall be resolved through 
              binding arbitration in accordance with the rules of the Indian Arbitration and Conciliation Act.
            </p>
          </section>

          <section className="terms-section">
            <h2>16. Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be 
              limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in 
              full force and effect.
            </p>
          </section>

          <section className="terms-section">
            <h2>17. Entire Agreement</h2>
            <p>
              These Terms constitute the entire agreement between you and ProjectPro regarding the Service and 
              supersede all prior agreements and understandings.
            </p>
          </section>

          <section className="terms-section">
            <h2>18. Contact Information</h2>
            <p>If you have any questions about these Terms, please contact us:</p>
            <ul>
              <li>Email: legal@projectpro.com</li>
              <li>Address: Mumbai, Maharashtra, India</li>
            </ul>
          </section>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default TermsOfService;


